import Box, { BoxProps } from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { forwardRef } from 'react';
// @mui
import { useDeeplinkContext } from 'src/contexts/DeepLinkContext';
import paths from 'src/router/paths';
// routes

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(({ disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();
  const { navigateToSectionInTab } = useDeeplinkContext();

  const PRIMARY_MAIN = theme.palette.common.black;

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        width: 161,
        height: 43,
        display: 'inline-flex',
        ...sx,
      }}
      {...other}
    >
      <svg width="161" height="43" viewBox="0 0 161 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.2418 26.7066C19.0465 27.3007 19.9862 27.5221 21.0502 27.3493C22.1033 27.1818 22.9242 26.6796 23.5183 25.8587C24.1124 25.0378 24.3122 24.0926 24.1448 23.0233C23.9774 21.9701 23.4859 21.133 22.6704 20.539C22.0331 20.0799 21.331 19.8531 20.5533 19.8531C20.3319 19.8531 20.0996 19.8747 19.862 19.9071C18.7981 20.0799 17.9718 20.566 17.3939 21.3815C16.7998 22.2024 16.6 23.1475 16.7674 24.2006C16.9402 25.2646 17.4263 26.1071 18.2472 26.6958L18.2418 26.7066Z"
          fill="url(#paint0_linear_1905_118310)"
        />
        <path
          d="M18.3714 17.0879C18.3714 17.0879 18.3822 17.0879 18.3876 17.0879C19.889 16.5046 20.9422 15.0302 20.9044 13.3236C20.8612 11.1903 19.1329 9.47287 17.005 9.45127C16.9618 9.45127 16.924 9.45127 16.8754 9.45127C16.8268 9.45127 16.762 9.45127 16.6972 9.46207C16.2759 9.49447 15.8547 9.51067 15.4388 9.45127C12.9653 9.09482 10.8644 7.05875 10.9562 4.54201C10.967 4.32598 11.0048 4.10455 10.9994 3.87772C10.9994 3.78051 10.9886 3.68869 10.9832 3.58608C10.7996 1.56621 9.09837 0 7.0461 0C6.85167 0 6.65185 0.0162022 6.45202 0.0432058C4.68598 0.302441 3.2818 1.77684 3.10897 3.55368C2.87674 5.9516 4.7778 7.94987 7.11631 7.90126C7.15951 7.90126 7.19732 7.90126 7.24593 7.89586C7.29993 7.89586 7.35394 7.89586 7.41335 7.88506C7.47276 7.87966 7.53757 7.87966 7.59157 7.87426C10.5188 7.82025 12.9437 10.148 13.0031 13.0806V13.1508C13.0031 13.2534 13.0031 13.3614 12.9977 13.464C12.8681 16.0023 10.9454 18.0816 8.45569 18.4381C8.01283 18.5029 7.55917 18.4813 7.11091 18.4381C7.0191 18.4273 6.92188 18.4219 6.83007 18.4219C6.71125 18.4219 6.59784 18.4165 6.48982 18.4219C2.5905 18.4975 -0.460907 21.9323 0.0575629 25.9181C0.446415 28.9101 2.90374 31.308 5.90655 31.6212C9.84367 32.0317 13.1435 28.9965 13.2299 25.1998C13.2353 25.1026 13.2353 25.0108 13.2299 24.9135C13.2299 24.7515 13.2191 24.5895 13.2029 24.4329C13.1057 23.3797 13.1597 22.305 13.5486 21.3221C14.2885 19.4534 15.7899 17.8116 17.7665 17.2661C17.9664 17.2121 18.1716 17.1635 18.366 17.0879H18.3714Z"
          fill="url(#paint1_linear_1905_118310)"
        />
        <path
          d="M54.5202 8.6416C50.81 8.6416 47.6991 9.84056 45.231 12.2385C42.7683 14.658 41.5207 17.6554 41.5207 21.2253C41.5207 24.7952 42.7629 27.8142 45.231 30.2337C47.6991 32.6532 50.81 33.8522 54.5202 33.8522C58.2305 33.8522 61.3198 32.6532 63.7825 30.2337C66.2506 27.8142 67.4928 24.8168 67.4928 21.2253C67.4928 17.6338 66.2452 14.658 63.7825 12.2385C61.3144 9.84056 58.2305 8.6416 54.5202 8.6416ZM58.7382 25.4865C57.6095 26.6152 56.2053 27.1931 54.5202 27.1931C52.8352 27.1931 51.4094 26.6152 50.3023 25.4865C49.1735 24.3577 48.6227 22.9265 48.6227 21.2253C48.6227 19.5241 49.1735 18.1145 50.3023 16.9857C51.4094 15.857 52.8136 15.3061 54.5202 15.3061C56.2269 15.3061 57.6095 15.857 58.7382 16.9857C59.867 18.1145 60.4178 19.5457 60.4178 21.2253C60.4178 22.9049 59.867 24.3577 58.7382 25.4865Z"
          fill={PRIMARY_MAIN}
        />
        <path
          d="M82.118 8.6416C78.4077 8.6416 75.2968 9.84056 72.8287 12.2385C70.366 14.658 69.1184 17.6554 69.1184 21.2253C69.1184 24.7952 70.3606 27.8142 72.8287 30.2337C75.2968 32.6532 78.4077 33.8522 82.118 33.8522C85.8282 33.8522 88.9175 32.6532 91.3802 30.2337C93.8483 27.8142 95.0905 24.8168 95.0905 21.2253C95.0905 17.6338 93.8483 14.658 91.3802 12.2385C88.9121 9.84056 85.8282 8.6416 82.118 8.6416ZM86.3359 25.4865C85.2072 26.6152 83.803 27.1931 82.118 27.1931C80.4329 27.1931 79.0071 26.6152 77.9 25.4865C76.7712 24.3577 76.2204 22.9265 76.2204 21.2253C76.2204 19.5241 76.7712 18.1145 77.9 16.9857C79.0071 15.857 80.4113 15.3061 82.118 15.3061C83.8246 15.3061 85.2072 15.857 86.3359 16.9857C87.4647 18.1145 88.0155 19.5457 88.0155 21.2253C88.0155 22.9049 87.4647 24.3577 86.3359 25.4865Z"
          fill={PRIMARY_MAIN}
        />
        <path d="M104.153 9.21408H97.2616V33.2743H104.153V9.21408Z" fill={PRIMARY_MAIN} />
        <path
          d="M119.297 15.3007C122.062 15.3007 124.227 17.0289 124.94 19.5403H132.129C131.734 16.3592 130.352 13.7561 127.981 11.7038C125.583 9.65154 122.677 8.6416 119.291 8.6416C115.581 8.6416 112.47 9.84056 110.002 12.2385C107.539 14.658 106.292 17.6554 106.292 21.2253C106.292 24.7952 107.534 27.8142 110.002 30.2337C112.47 32.6532 115.581 33.8522 119.291 33.8522C122.677 33.8522 125.583 32.8152 127.981 30.763C130.352 28.7107 131.734 26.1075 132.129 22.9265H124.94C124.595 24.1957 123.925 25.2056 122.91 25.9941C121.873 26.7988 120.674 27.1931 119.291 27.1931C117.585 27.1931 116.18 26.6152 115.073 25.4865C113.944 24.3577 113.394 22.9265 113.394 21.2253C113.394 19.5241 113.944 18.1145 115.073 16.9857C116.18 15.857 117.585 15.3061 119.291 15.3061L119.297 15.3007Z"
          fill={PRIMARY_MAIN}
        />
        <path
          d="M147.089 8.6416C143.378 8.6416 140.268 9.84056 137.799 12.2385C135.337 14.658 134.089 17.6554 134.089 21.2253C134.089 24.7952 135.331 27.8142 137.799 30.2337C140.268 32.6532 143.378 33.8522 147.089 33.8522C150.037 33.8522 152.641 33.0691 154.898 31.5245C157.134 29.9799 158.7 27.9546 159.575 25.4433H152.268C151.436 26.8258 149.503 27.8412 147.224 27.8412C144.388 27.8412 142.223 26.1615 141.461 23.4612H159.872C159.986 22.9535 160.056 22.2406 160.056 21.3441C160.056 17.677 158.814 14.6634 156.345 12.2439C153.856 9.84596 150.772 8.647 147.083 8.647L147.089 8.6416ZM141.515 18.8706C142.347 16.2188 144.394 14.5824 147.094 14.5824C149.794 14.5824 151.933 16.2188 152.646 18.8706H141.515Z"
          fill={PRIMARY_MAIN}
        />
        <path
          d="M28.6184 9.21408C26.2421 9.21408 24.314 11.1421 24.314 13.5185V16.5483H32.2261V31.2922C32.2261 32.421 31.8588 33.3877 31.1027 34.1492C30.3358 34.9053 29.3907 35.305 28.2187 35.305C27.0468 35.305 26.1394 34.9053 25.3887 34.1492C24.6218 33.3823 24.26 32.421 24.26 31.2922H16.7422C16.7422 34.4463 17.8547 37.0764 20.042 39.1719C22.2239 41.289 24.9243 42.3529 28.1755 42.3529C31.4268 42.3529 34.1163 41.2944 36.309 39.1719C38.4747 37.0764 39.5602 34.4463 39.5602 31.2922V9.21408H28.6184Z"
          fill={PRIMARY_MAIN}
        />
        <defs>
          <linearGradient
            id="paint0_linear_1905_118310"
            x1="12.1009"
            y1="0"
            x2="12.1009"
            y2="31.6585"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF301F" />
            <stop offset="1" stopColor="#F79300" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1905_118310"
            x1="12.1009"
            y1="0"
            x2="12.1009"
            y2="31.6585"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF301F" />
            <stop offset="1" stopColor="#F79300" />
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Box
      onClick={(e) => {
        e.preventDefault();
        navigateToSectionInTab(paths.app.dashboard);
      }}
    >
      {logo}
    </Box>
  );
});

Logo.displayName = 'Logo';

export default Logo;
